import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

// Avisa antes de abandonar una página con progreso sin guardar (links internos, botón atrás, cerrar pestaña).
export function useLeaveGuard(active) {
  const navigate = useNavigate();
  const [pending, setPending] = useState(null);
  const bypass = useRef(false);
  const activeRef = useRef(active);
  activeRef.current = active;

  useEffect(() => {
    const onBeforeUnload = (e) => {
      if (!activeRef.current || bypass.current) return;
      e.preventDefault();
      e.returnValue = "";
    };
    const onClick = (e) => {
      if (!activeRef.current || bypass.current || e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      const a = e.target.closest?.("a[href]");
      if (!a || a.target === "_blank") return;
      const url = new URL(a.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      const to = url.pathname + url.search + url.hash;
      if (to === window.location.pathname + window.location.search) return;
      e.preventDefault();
      e.stopPropagation();
      setPending({ to });
    };
    const onPopState = () => {
      if (!activeRef.current || bypass.current) return;
      window.history.pushState(null, "", window.location.href);
      setPending({ back: true });
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    document.addEventListener("click", onClick, true);
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
      document.removeEventListener("click", onClick, true);
      window.removeEventListener("popstate", onPopState);
    };
  }, []);

  const armed = useRef(false);
  useEffect(() => {
    if (active && !armed.current) {
      armed.current = true;
      window.history.pushState(null, "", window.location.href);
    }
  }, [active]);

  const confirmLeave = () => {
    const p = pending;
    bypass.current = true;
    setPending(null);
    if (p?.back) window.history.go(-2);
    else if (p?.to) navigate(p.to);
  };

  return {
    open: !!pending,
    cancel: () => setPending(null),
    confirmLeave,
    allowLeave: () => { bypass.current = true; },
  };
}
